import darkScrollbar from "@mui/material/darkScrollbar"
import { Components, Theme, alpha } from "@mui/material/styles"

import { neutral } from "@constants/colors"

import { ThemeProps } from "./types"

export const muiCssBaseline = ({
  darkMode,
}: ThemeProps): Components<Omit<Theme, "components">>["MuiCssBaseline"] => {
  return {
    styleOverrides: {
      html: {
        overscrollBehavior: "none",
        ...darkScrollbar(
          darkMode
            ? {
                track: "transparent",
                thumb: alpha(neutral.black, 0.6),
                active: alpha(neutral.black, 0.5),
              }
            : {
                track: "transparent",
                thumb: alpha(neutral.black, 0.4),
                active: alpha(neutral.black, 0.5),
              },
        ),
        //scrollbarWidth for Firefox
        scrollbarWidth: "thin",
      },
      ".cl-organizationSwitcher-root *": {
        "--cl-shimmer-hover-transform": "none!important",
        "--cl-shimmer-hover-after-transform": "none!important",
      },
    },
  }
}
